import { useTranslations } from "@/lib/static-intl";
import ContentSubCommentListTile from "../content-sub-comment-list-tile";
import { useState } from "react";

const ContentSubCommentList = ({
  subComments,
  parentCommentId,
  setAllPostComments,
  selectedPostInModal,
  setCurrentCommentInReply,
  handleReportComment,
  triggerFullScreenImageSlider,
  currentUserFollowing,
  setCurrentUserFollowing,
}) => {
  const explorePostDetailsT = useTranslations("explore.explore_post_details");

  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div className="w-full flex flex-col gap-4 py-2">
      {isExpanded ? (
        <>
          {subComments.map((comment, i) => (
            <ContentSubCommentListTile
              key={i}
              comment={comment}
              parentCommentId={parentCommentId}
              setAllPostComments={setAllPostComments}
              selectedPostInModal={selectedPostInModal}
              setCurrentCommentInReply={setCurrentCommentInReply}
              handleReportComment={handleReportComment}
              triggerFullScreenImageSlider={triggerFullScreenImageSlider}
              currentUserFollowing={currentUserFollowing}
              setCurrentUserFollowing={setCurrentUserFollowing}
            />
          ))}
        </>
      ) : (
        <>
          {subComments.slice(0, 1).map((comment, i) => (
            <ContentSubCommentListTile
              key={i}
              comment={comment}
              parentCommentId={parentCommentId}
              setAllPostComments={setAllPostComments}
              selectedPostInModal={selectedPostInModal}
              setCurrentCommentInReply={setCurrentCommentInReply}
              handleReportComment={handleReportComment}
              triggerFullScreenImageSlider={triggerFullScreenImageSlider}
              currentUserFollowing={currentUserFollowing}
              setCurrentUserFollowing={setCurrentUserFollowing}
            />
          ))}
        </>
      )}
      {subComments.length > 1 && (
        <button
          className="text-action font-semibold text-sm w-fit"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded
            ? explorePostDetailsT("show_less")
            : explorePostDetailsT("expand")}
        </button>
      )}
    </div>
  );
};

export default ContentSubCommentList;
